import { use } from 'react';
import { LoginContext } from './loginContext';

export function useLoginContext() {
  return use(LoginContext)!;
}
